import { SVGProps } from 'react';
import { MULTIPLE_INVITE, SINGLE_INVITE } from '@components/process-invite-guest/src/process-invite-guest.type';
import {
  MULTIPLE_OFFLINE_SELL,
  SINGLE_OFFLINE_SELL,
} from '@components/process-offline-sales/src/process-offline-sales.type';
export type MultiOptionType =
  | typeof SINGLE_OFFLINE_SELL
  | typeof MULTIPLE_OFFLINE_SELL
  | typeof SINGLE_INVITE
  | typeof MULTIPLE_INVITE;
export const createMultiSelectorOption = ({
  id,
  name,
  subtitle,
  icon,
  value,
  toggler,
}: {
  id: typeof SINGLE_OFFLINE_SELL | typeof MULTIPLE_OFFLINE_SELL | typeof SINGLE_INVITE | typeof MULTIPLE_INVITE;
  name: string;
  subtitle: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  value: string;
  toggler: (id: MultiOptionType) => void;
}) => ({
  name,
  subtitle,
  bordered: true,
  id,
  icon,
  active: value === id,
  wrapperClasses: 'flex-1',
  action: () => toggler(id),
});
